export default __webpack_public_path__ + "static/ringwithblob-a93375593df1342a8ab67d691f38db72.png";